<template>
  <div class="bg">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout pa-7 align-center justify-center>
            <v-flex xs12 sm8 md6>
              <v-spacer />
              <v-card class="elevation-12 pa-5">
                <v-toolbar-title>
                  <v-img class="logo mt-2" src="logo-color.png" />
                </v-toolbar-title>
                <v-card-title primary-title>
                  <div>
                    <span class="subheading font-weight-medium">{{
                      $t('action.messages.setNewPassword')
                    }}</span>
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="password"
                      prepend-icon="lock"
                      name="password"
                      :rules="[rules.vacio, rules.min]"
                      :label="$t('fields.resetPassword.newPassword')"
                      required
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="
                        showPassword ? 'visibility' : 'visibility_off'
                      "
                      @click:append="showPassword = !showPassword"
                    />
                    <v-text-field
                      v-model="password2"
                      prepend-icon="lock"
                      name="newPassword"
                      :rules="[rules.vacio, rules.min, comparePassword]"
                      :label="$t('fields.resetPassword.repeatPassword')"
                      :type="showPassword2 ? 'text' : 'password'"
                      :append-icon="
                        showPassword2 ? 'visibility' : 'visibility_off'
                      "
                      @keyup.enter="submit"
                      @click:append="showPassword2 = !showPassword2"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    small
                    color="error"
                    @click="$router.push({ name: 'login' })"
                  >
                    <span>{{ $t('action.buttons.cancel') }}</span>
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    ::loading="loading"
                    @click="submit"
                  >
                    {{ $t('action.buttons.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer class="pa-3 footer-bg">
        <span class="caption"
          >FBASE.Tv &copy; {{ new Date().getFullYear() }}</span
        >
        <v-spacer />
        <span class="caption mr-1">
          <a to>{{ $t('titles.global.termsAndConditions') }}</a> |
          <a to>{{ $t('titles.global.termsOfUse') }}</a>
        </span>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import rules from '../../helpers/rules'
export default {
  mixins: [rules],
  data: () => ({
    password: '',
    password2: '',
    showPassword: false,
    showPassword2: false,
    loading: false,
    valid: true,
  }),
  computed: {
    comparePassword() {
      return (
        this.password === this.password2 ||
        this.$t('error.error.passwordDoNotMatch')
      )
    },
  },
  methods: {
    ...mapActions({
      resetPassword: 'users/resetPassword',
    }),
    submit() {
      if (this.$refs.form.validate() && this.comparePassword) {
        this.loading = true
        const data = {
          tk: this.$route.params.tk,
          userId: this.$route.params.userId,
          newPassword: this.password,
        }
        this.resetPassword(data)
          .then(() => {
            this.$router.push({ name: 'login' })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style>
.logo {
  margin: auto;
  max-width: 250px;
}
.bg {
  background-image: url(/dark-material-bg.jpg);
  background-size: cover;
  background-color: #00482b;
}
#inspire {
  background: none;
}
.footer-bg {
  color: white !important;
  background-color: transparent !important;
}
</style>
